ACDiscountApp.PDPage.DisplayTiers = function () {
//changes in this fiels [head_assets,swatch.min]
 
  var tabelSelectorPDpage = 'form[action="/cart/add"] .flex.wrap'; // Tiered Table Selector;
  var tabelQuantitySelectorPDpage = 'form[action="/cart/add"] .flex.wrap input';// add quantity box selecter
  var addToCartSelecter = '.product-form .product-form__buttons button[name="add"]';// add t cart button selecter
  var VarintChangeSelectorPDpage = 'form[action="/cart/add"] .swatches-select li,form[action="/cart/add"] .swatches-select li,form[action="/cart/add"] select, form[action="/cart/add"] input, form[action="/cart/add"] .flex.wrap .plus, form[action="/cart/add"] .flex.wrap .minus';
    let customerMemberOrNot = globalFields.customerTagsCheck();
  
  var storeTime = globalFields.Storetime();
  // Parse the date string into individual components
  let [currentYear, currentMonth, currentDay, currentHours, currentMinutes, currentSeconds] = storeTime.split(/[\sT:-]/);
  currentYear = parseInt(currentYear);
  currentMonth = parseInt(currentMonth); // Months are zero-based in JavaScript
  currentDay = parseInt(currentDay);
  currentHours = parseInt(currentHours);
  currentMinutes = parseInt(currentMinutes);
  currentSeconds = parseInt(currentSeconds);

    function makeTimer(end_date) {
    if (globalFields.isProduct_Page) {
      if (end_date != null) {
        jQuery("#ac_countDown").css("display", "block");
        var endTime = end_date;
        // Increment seconds by 1
        currentSeconds++;

        // Adjust minutes, hours, and day if necessary
        if (currentSeconds >= 60) {
          currentSeconds = 0;
          currentMinutes++;
          if (currentMinutes >= 60) {
            currentMinutes = 0;
            currentHours++;
            if (currentHours >= 24) {
              currentHours = 0;
              currentDay++;
            }
          }
        }

        // Reformat the updated timestamp
        let currentStoreTime = `${currentYear}-${currentMonth.toString().padStart(2, '0')}-${currentDay.toString().padStart(2, '0')}T${currentHours.toString().padStart(2, '0')}:${currentMinutes.toString().padStart(2, '0')}:${currentSeconds.toString().padStart(2, '0')}`;
        endTime = (Date.parse(endTime) / 1000);
        var now = currentStoreTime;
        now = (Date.parse(now) / 1000);
        var timeLeft = endTime - now;
        var days = Math.floor(timeLeft / 86400);
        var hours = Math.floor(timeLeft / 3600);
        var exactHour = hours % 24;
        var minutes = Math.floor((timeLeft - (hours * 3600)) / 60);
        var seconds = Math.floor((timeLeft - (hours * 3600) - (minutes * 60)));
        var isDays = false;
        if (days > 0 || hours > 24) { isDays = true; }
        if (days < 0) { days = "00"; /*hours = "0"; minutes = "0"; seconds = "0";*/ }
        if (hours < 10) { hours = "0" + hours; }
        if (minutes < 10) { minutes = "0" + minutes; }
        if (seconds < 10) { seconds = "0" + seconds; }
        if (timeLeft > 0) {
          if (isDays) {
            $(".ac__days").html(days); $(".ac__hours").html(exactHour); $(".ac__minutes").html(minutes);
            $(".ac_sec, .ac__colon.seconds").hide();
          }
          else {
            $(".ac__hours").html(exactHour); $(".ac__minutes").html(minutes); $(".ac__seconds").html(seconds);
            $(".ac_day, .ac__colon.hours").hide(); $(".ac_sec, .ac__colon.seconds").show();
          }
        }
        else { jQuery('.ac__settings__table, #ac_countDown').remove(); }

        setTimeout(function () {
          jQuery('.ac__settings__table').after(jQuery("#ac_countDown"));
        }, 500);
      }
    }
  }

    var hide_buttons = null;
    var HideAdditionalPayments = function () {
    hide_buttons = setInterval(function () {
      if (jQuery('.shopify-payment-button__button').length > 0) {
        jQuery('.shopify-payment-button__button').hide();
        clearInterval(hide_buttons);
      }
    }, 500);
  }

    this.DisplayTiersFn = function () {
    setTimeout(function () {
      jQuery('.ac__settings__table').remove();
      var selectedVariant = jQuery('input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]', jQuery('form[action="/cart/add"]')).val();
      let ProductPage = globalFields.TableProductPage != undefined && globalFields.TableProductPage != '' ? globalFields.TableProductPage : 'true';
      ProductPage = ProductPage == 'true' ? true : false;
      if (selectedVariant != null && globalFieldsProductPage_AC.productMetafield != '[]' && globalFieldsProductPage_AC.productMetafield != undefined && ProductPage) {
        let tierObj = globalFields.GetTierObject(globalFieldsProductPage_AC.productMetafield, selectedVariant);
        let DiscountAppliedOn = false;
        let Location_Tag_s = false;
        if (tierObj != undefined) {
          DiscountAppliedOn = tierObj.DiscountAppliedON != null && tierObj.DiscountAppliedON != '' && tierObj.DiscountAppliedON != undefined ? true : false;
          Location_Tag_s = tierObj.Location_Tag_ != null && tierObj.Location_Tag_ != '' && tierObj.Location_Tag_ != undefined ? true : false;
        }else{
          return
        }
        if (DiscountAppliedOn) {
          // 1
          if (Location_Tag_s) {
            // 2
            let DiscountAppliedOnTag = tierObj.DiscountAppliedON == 'Both_Store' || tierObj.DiscountAppliedON == 'Online_Store' ? true : false;

            let LocationObject = Object.keys(tierObj.Location_Tag_);
            if (LocationObject[0] == 'StoreLocation') {
              let StoreLocationcheck = tierObj.Location_Tag_[LocationObject[0]].includes(globalFields.Storecountry) || tierObj.Location_Tag_[LocationObject[0]].includes(globalFields.Storecity) ? true : false;
              if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && DiscountAppliedOnTag && StoreLocationcheck) {
                var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
                getDates.valid; getDates.start_date; getDates.end_date;
                let timer_settings = parsed_timer_settings;
                WriteTableHeading(tierObj);
                WriteTableRows(tierObj, selectedVariant);
                if (timer_settings != undefined) {
                  if (timer_settings.TimerStatus) {
                    if (getDates.valid) {
                      setInterval(function () { makeTimer(getDates.end_date); }, 1000);
                    }
                  }
                }
                jQuery('.shopify-payment-button__button').hide();
                setTimeout(function () {
                  jQuery('.shopify-payment-button__button').hide();
                  HideAdditionalPayments();
                }, 2000);
                setTimeout(function () {
                  clearInterval(hide_buttons);
                }, 5000);
              }
            }
            else {
              // 3
              let TierLocation = tierObj.Location_Tag_[LocationObject[0]];
              let CusotmerCountryLocation = globalFields.Customercountry;
              let CusotmerCityLocation = globalFields.Customercity;
              let CustomerLocationcheck_1 = (arr, arr1) => { return arr.some(item => arr1.includes(item)) };
              let CustomerLocationcheck_2 = (arr2, arr3) => { return arr2.some(item => arr3.includes(item)) };
              let CityValue = CustomerLocationcheck_1(TierLocation, CusotmerCountryLocation);
              let CountryValue = CustomerLocationcheck_2(TierLocation, CusotmerCityLocation);

              if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && DiscountAppliedOnTag && (CityValue || CountryValue)) {
                var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
                getDates.valid; getDates.start_date; getDates.end_date;
                let timer_settings = parsed_timer_settings;
                WriteTableHeading(tierObj);
                WriteTableRows(tierObj, selectedVariant);
                if (timer_settings != undefined) {
                  if (timer_settings.TimerStatus) {
                    if (getDates.valid) {
                      setInterval(function () { makeTimer(getDates.end_date); }, 1000);
                    }
                  }
                }
                jQuery('.shopify-payment-button__button').hide();
                setTimeout(function () {
                  jQuery('.shopify-payment-button__button').hide();
                  HideAdditionalPayments();
                }, 2000);
                setTimeout(function () {
                  clearInterval(hide_buttons);
                }, 5000);
              }
            }

          }
          else {
            // 4
            if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && (tierObj.DiscountAppliedON == 'Both_Store' || tierObj.DiscountAppliedON == 'Online_Store')) {
              var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
              getDates.valid; getDates.start_date; getDates.end_date;
              let timer_settings = undefined//parsed_timer_settings;                
              WriteTableHeading(tierObj);
              WriteTableRows(tierObj, selectedVariant);
              if (timer_settings != undefined) {
                if (timer_settings.TimerStatus) {
                  if (getDates.valid) {
                    setInterval(function () { makeTimer(getDates.end_date); }, 1000);
                  }
                }
              }
              jQuery('.shopify-payment-button__button').hide();
              setTimeout(function () {
                jQuery('.shopify-payment-button__button').hide();
                HideAdditionalPayments();
              }, 2000);
              setTimeout(function () {
                clearInterval(hide_buttons);
              }, 5000);
            }
          }
        }
        else {
          // 5
          let temptimer = globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date)
          if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date)) {
            var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
            getDates.valid; getDates.start_date; getDates.end_date;
            let timer_settings = undefined//parsed_timer_settings;                
            WriteTableHeading(tierObj);
            WriteTableRows(tierObj, selectedVariant);
            if (timer_settings != undefined) {
              if (timer_settings.TimerStatus) {
                if (getDates.valid) {
                  setInterval(function () { makeTimer(getDates.end_date); }, 1000);
                }
              }
            }
            jQuery('.shopify-payment-button__button').hide();
            setTimeout(function () {
              jQuery('.shopify-payment-button__button').hide();
              HideAdditionalPayments();
            }, 2000);
            setTimeout(function () {
              clearInterval(hide_buttons);
            }, 5000);
          }
        }
      }
    }, 200);
     displayTiers.changePrice();//call this function for change the PDP price 
    displayTiers.OnQuantityChange();//call this function for change the PDP price
  }


    setTimeout(function () {
    clearInterval(hide_buttons);
  }, 10000);

this.OnQuantityChange = function () {
  /*
    // Debounce function to avoid frequent calls
    function debounce(func, wait) {
        let timeout;
        return function(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    // Debounced version of displayTiers.DisplayTiersFn
    const debouncedDisplayTiers = debounce(displayTiers.DisplayTiersFn, 800);

    // Attach event listener only once
    $(VarintChangeSelectorPDpage).off('change keyup click').on('change keyup click', function (e) {
        debouncedDisplayTiers();  // Call debounced function
    });
    */
   // varintChange()
// $(VarintChangeSelectorPDpage).one('click', function(){
//     setTimeout(varintChange, 10);
// });
};
  
  $(document).ready(function() {
    VarintChangeSelectorPDpage = '.row.product form[action="/cart/add"] .swatches-select li,.row.product form[action="/cart/add"] select,.row.product form[action="/cart/add"] input,.row.product form[action="/cart/add"] .flex.wrap .plus,.row.product form[action="/cart/add"] .flex.wrap .minus';
 
    $(document).on('click', VarintChangeSelectorPDpage, function () {
        setTimeout( displayTiers.DisplayTiersFn(), 10); // Optional delay
      
    });


        
        setTimeout(function() {
// Target the element you want to observe
const targetNode = document.querySelector('.row.product .flex_.wrap_.fl_between.al_center.price-review.rating_t4s_true #price_ppr');

if (targetNode) {
    // Create a MutationObserver instance
    const observer = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList' || mutation.type === 'subtree') {
               setTimeout(displayTiers.DisplayTiersFn, 10); // Call your function
            }
        }
    });

    // Configuration options for the observer (which mutations to observe)
    const config = {
        childList: true, // Observe direct children
        subtree: true,   // Observe all descendants (optional, remove if not needed)
        characterData: true // Observe changes to text content
    };

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
} else {
   // console.warn("Target node not found!");
}

        }, 200);

});
  
  
    var TableHeadHtml = function (contentHtml, tableSelector, position) {
    let tableShowAfter = false;
   jQuery(tableSelector)[globalFields.settings.table_body.table_placed == 'after' ? 'after' : 'before'](contentHtml);
  }

    var WriteTableHeading = function (tierObj) {
    var tableSelector = tabelSelectorPDpage;
    if (globalFields.settings.selected_table == "table1") {
      TableHeadHtml('<table class="ac__settings__table ac_table1" id="ac_table1"><tbody class="ac__tbody"><tr class="ac__tr ac__tr1"><th class="ac__th ac__th1" style=" word-break: auto-phrase; " >' + globalFields.settings.table_headers.header1_value + '</th><th class="ac__th ac__th2" style=" word-break: auto-phrase; " >' + globalFields.settings.table_headers.header2_value + '</th></tr></tbody></table>', tableSelector);
    }
    if (globalFields.settings.selected_table == "table2") {

      TableHeadHtml('<table class="ac__settings__table ac_table2" id="ac_table2"><tbody class="ac__tbody"><tr class="ac__tr ac__tr1"><th class="ac__th ac__th1" style=" word-break: auto-phrase; " >' + globalFields.settings.table_headers.header1_value + '</th><th class="ac__th ac__th2" style=" word-break: auto-phrase; ">' + globalFields.settings.table_headers.header2_value + '</th><th class="ac__th ac__th3" style=" word-break: auto-phrase; " >' + globalFields.settings.table_headers.header3_value + '</th></tr></tbody></table>', tableSelector);
    }

    if (globalFields.settings.selected_table == "table3") {
      TableHeadHtml('<table class="ac__settings__table ac_table3" id="ac_table3"><tbody class="ac__tbody"><tr class="ac__tr ac__tr1"><th class="ac__th ac__th1" style=" word-break: auto-phrase; ">' + globalFields.settings.table_headers.header1_value + '</th><th class="ac__th ac__th2" style=" word-break: auto-phrase; " >' + globalFields.settings.table_headers.header2_value + '</th><th class="ac__th ac__th3" style=" word-break: auto-phrase; ">' + globalFields.settings.table_headers.header3_value + '</th></tr></tbody></table>', tableSelector);
    }

    if (globalFields.settings.selected_table == "table4") {
      TableHeadHtml('<table class="ac__settings__table ac_table4" id="ac_table4"><tbody class="ac__tbody"></tbody></table>', tableSelector);
    }
        if (globalFields.settings.selected_table == "table5") {
    TableHeadHtml('<div class="ac__settings__table ac_table5" id="ac_table5" style="border: none;"><div class="ac__tbody"></div></div>',tableSelector);
    }
  }

    var TableRowHtml = function (contentHtml, tableSelector) {
    jQuery(tableSelector).append(contentHtml);
  }
  
    function formatNumberWithCommas(number) {
  if (typeof number !== 'number') {
    return number;
  }
  return number;
  }

    var TableRowSingle = function (tieredMin_, tieredMax_, discountedPrice, tieredOff, index ,extraSign) {
   var plusSign =  tieredMin_ == tieredMax_ ? '' : '+', buyText = 'Buy ';
   var buyText = 'Buy '
    if(extraSign){
     plusSign  = ''
    tieredMin_ = tieredMin_ + "-" + tieredMax_;
    }
       
      var priceHtml = '<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + discountedPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(discountedPrice, globalFields.amount) + '</span>';
      if (globalFields.settings.selected_table == "table1") {
          TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + plusSign + '</td><td class="ac__td ac__td2">' + tieredOff + '</td></tr>', '#ac_table1 .ac__tbody');
      }

      if (globalFields.settings.selected_table == "table2") {
          TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + '</td><td class="ac__td ac__td2">' + tieredMax_ + '</td><td class="ac__td ac__td3">' + tieredOff + '</td></tr>', '#ac_table2 .ac__tbody');
      }

      if (globalFields.settings.selected_table == "table3") {
          TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + plusSign  +'</td><td class="ac__td ac__td2">' + priceHtml + '</td><td class="ac__td ac__td3">' + tieredOff + '</td></tr>', '#ac_table3 .ac__tbody');
      }

      if (globalFields.settings.selected_table == "table4") {
          var quantityTextTable4 = tieredMin_ + "-" + tieredMax_;
          if (tieredMax_ == "+") {
              quantityTextTable4 = tieredMin_ + "+";
          }
          TableRowHtml('<tr class="ac__tr ac__tr' + index + '"> <td class="ac__td ac__td1">' + globalFields.settings.table_body.body1_value + ' ' + tieredMin_ + ' ' + globalFields.settings.table_body.body2_value + ' ' + tieredOff + '</td></tr>', '#ac_table4');
      }


  }

    var WriteTableRows = function (tierObj, selectedVariant_) {
    
    var originalPrice_ = globalFieldsProductPage_AC.variantsPriceArray_PD[selectedVariant_]; originalPrice_ = originalPrice_ / 100;
     originalPrice_ = CalculateTradePlusDiscount(originalPrice_)// give trade+ discount
   
      for (i = 0; i < tierObj.tier_min.length; i++) {
          var isBreakLoop = false, tieredOff = Number(tierObj.tier_values[i]);
        let discountSign = ""
          var tieredMin_ = parseInt(tierObj.tier_min[i]), tieredMax_ = tierObj.tier_max[i], discountedPrice = 0;

          if (tieredMax_ != "max") {
              tieredMax_ = parseInt(tieredMax_);
          }
          else {
              tieredMax_ = "+";
          }

          if (tierObj.discount_type == "percentage") {
              discountedPrice = Number(originalPrice_.toFixed(2));
              var p = parseFloat(tieredOff) / 100, originalPriceCut_ = Number(parseFloat(p * discountedPrice).toFixed(2));
              discountedPrice = discountedPrice - originalPriceCut_;
              if (discountedPrice <= 0) {
                  discountedPrice = 0;
                  tieredOff = "100%";
                  isBreakLoop = true;
                  tieredMax_ = "+";
                  discountSign = '0% '
              }
              else {
                  discountedPrice = discountedPrice.toFixed(2);
                  tieredOff = tieredOff.toFixed() + "% ";
                    discountSign = '0% '
              }
          }
          else if (tierObj.discount_type == "fixed_price") {
              discountedPrice = tieredOff.toFixed(2);
              tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount);
              discountSign = globalFields.formatMoney('0', globalFields.amount)
          }
          else {
              discountedPrice = Number((originalPrice_ - tieredOff).toFixed(2));
              if (discountedPrice <= 0) {
                  discountedPrice = 0;
                  tieredOff = globalFields.formatMoney(originalPrice_.toFixed(2), globalFields.amount);
                  discountSign = globalFields.formatMoney('0', globalFields.amount)
                  isBreakLoop = true;
                  tieredMax_ = "+";
              }
              else {
                  discountedPrice = discountedPrice.toFixed(2);
                  tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount) + " OFF";
                   discountSign = globalFields.formatMoney('0', globalFields.amount) + " OFF"
              }
          }
if (tierObj.discount_type != "percentage") {
    if ( Number(originalPrice_.toFixed(2)) <= 0) {
        throw new Error("Original price must be greater than zero.");
    }

    const discount =  Number(originalPrice_.toFixed(2)) - discountedPrice;
    const discountPercentage = (discount /  Number(originalPrice_.toFixed(2))) * 100;

   tieredOff = discountPercentage.toFixed() + "%";


}
        
        
        if(i == 0 && tieredMin_ != 1){
          TableRowSingle(0, tieredMin_-1,  Number(originalPrice_.toFixed(2))*100,'0%', i + 1,true);
        }
          TableRowSingle(tieredMin_, tieredMax_, discountedPrice, tieredOff, i + 1,false);

          if (isBreakLoop) { break; }
      }
      
         let tableSize = $(`.ac_${globalFields.settings.selected_table} .ac__tbody tr`).length
          if(tableSize == 1){$(`.ac_${globalFields.settings.selected_table}`).hide();}
  }

    this.changePrice = function(){
      var selectedVariant = jQuery('input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]', jQuery('form[action="/cart/add"]')).val();
     let currencyRate = Shopify.currency.rate;
    currencyRate = Number(currencyRate);
    if(selectedVariant == ""){ 
          let id_= Object.keys(globalFieldsProductPage_AC.variantsPriceArray_PD)
          selectedVariant = id_[0];
        }
      var mainProductPrice = globalFields.priceChangeFunc(selectedVariant);
       mainProductPrice = CalculateTradePlusDiscount(mainProductPrice);// give trade+ discount
      
      let productPriceWithoutMonney = mainProductPrice
      var mainProductPriceWithMoney  = globalFields.formatMoney(mainProductPrice, globalFields.amount);
        var originalChangeQty = jQuery(tabelQuantitySelectorPDpage).val();
        originalChangeQty = Number(originalChangeQty);
        if(isNaN(originalChangeQty)){
        	originalChangeQty = 1;
        }
        var updatedItemPrice = 0
        if (selectedVariant != null && globalFieldsProductPage_AC.productMetafield != '[]' && globalFieldsProductPage_AC.productMetafield != undefined && selectedVariant != "") {
          var tierObj = globalFields.GetTierObject(globalFieldsProductPage_AC.productMetafield, selectedVariant);
          if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date)) {
            for (i = 0; i < tierObj.tier_min.length; i++) {
              var tierPrice = parseFloat(tierObj.tier_values[i]);
              var minTier = parseInt(tierObj.tier_min[i]), maxTier = tierObj.tier_max[i] != 'max' ? parseInt(tierObj.tier_max[i]) : tierObj.tier_max[i];
              var updatedLinePrice = 0, condition1 = false, condition2 = false;
              // var originalPrice_ = (mainProductPrice / 100);
              //     originalPrice_ = originalPrice_;
				 var originalPrice_ = Number(mainProductPrice );
                  condition1 = originalChangeQty >= minTier;
                  condition2 = maxTier == "max" || originalChangeQty <= maxTier;
              if (condition1 && condition2) { break; }
            }
            
            if (condition1 && condition2) {
                if (tierObj.discount_type == 'percentage') {
                    var originalPriceCut = parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFields.ConvertToFixedDecimalNumber(originalPrice_)));
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(originalPrice_) - originalPriceCut);
                }
                else if (tierObj.discount_type == 'fixed') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(originalPrice_) - parseFloat(tierPrice * currencyRate));
                }
                else if (tierObj.discount_type == 'fixed_price') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(parseFloat(tierPrice * currencyRate));
                }
              
                 WriteProductDiscountHtml(updatedItemPrice,productPriceWithoutMonney)
                updatedItemPrice = globalFields.formatMoney(Number(updatedItemPrice).toFixed(2), globalFields.amount);
            }
            else{
              WriteProductDiscountHtml(productPriceWithoutMonney,0)
            }
          }else{ WriteProductDiscountHtml(productPriceWithoutMonney,0)}
          }
        else{
            WriteProductDiscountHtml(productPriceWithoutMonney,0)
          } 
  }//end changePrice function

  

    function CalculateTradePlusDiscount(productPrice) {
          let product_id = globalFields.productId
          let originalPrice_ = Number(productPrice);
          let TradeDiscountTier = globalFields.AllProductsMetafield;
          let tierDiscountAmount = globalFields.AllProductsMetafield != '[]' && globalFields.AllProductsMetafield.status ? Number(TradeDiscountTier.tier_values[0]) :0 ;

        /* if product have custom price start*/
          let customProductPrice = $('.row.product .flex_.wrap_.fl_between.al_center.price-review.rating_t4s_true .price_range').text();
          let tempCustomProductPrice = $('.row.product .flex_.wrap_.fl_between.al_center.price-review.rating_t4s_true .price_range del').text()
          if (tempCustomProductPrice) {
              customProductPrice = $('.row.product .flex_.wrap_.fl_between.al_center.price-review.rating_t4s_true .price_range ins').text()
          }
         customProductPrice = customProductPrice !== undefined && customProductPrice !== '' 
          ? parseFloat(customProductPrice.replace(/[^\d.,]/g, '').replace(/,/g, '')) 
          : 0;
            if (originalPrice_ == 0 || originalPrice_ != customProductPrice) {
            originalPrice_ = customProductPrice
            }  /* if product have custom price end*/
        
          var product_exclude =   isExcludedOnProductPage();
          if (!product_exclude && customerMemberOrNot == 'Trade+' && globalFields.isCustomer && globalFields.TradeMemberCustomer) {
              let TradePlusDiscount = originalPrice_ * tierDiscountAmount/100;
              originalPrice_ =  originalPrice_ - TradePlusDiscount;
          }
          
          return originalPrice_
      }//end of CalculateTradePlusDiscount

  

    function WriteProductDiscountHtml(price,productPrice) {
              let ProductUpdatedPrice = globalFields.formatMoney(price.toFixed(2), globalFields.amount);
              let ProductOriginalPrice = productPrice > 0 ? `<s>${globalFields.formatMoney(productPrice.toFixed(2), globalFields.amount)}</s>  `:''
  
              $('.ac-anncode-price').remove(); 
             // extra price hide start
              $('.row.product .flex_.wrap_.fl_between.al_center.price-review.rating_t4s_true #price_ppr').hide(); 
            //document.querySelector('.row.product .flex_.wrap_.fl_between.al_center.price-review.rating_t4s_true #price_ppr').style.setProperty('display', 'none', 'important');

document.addEventListener('DOMContentLoaded', () => {
    const element = document.querySelector('.row.product .flex_.wrap_.fl_between.al_center.price-review.rating_t4s_true #price_ppr');
    if (element) {
        element.style.setProperty('display', 'none', 'important');
    }
});

      
              $('.row.product #cart-form_ppr .price.price_varies').hide();
             //   document.querySelector('.row.product #cart-form_ppr .price.price_varies').style.setProperty('display', 'none', 'important');
                document.addEventListener('DOMContentLoaded', () => {
                const element = document.querySelector('.row.product #cart-form_ppr .price.price_varies');
                if (element) {
                    element.style.setProperty('display', 'none', 'important');
                }
            });


            // extra price hide end
             var product_exclude =   isExcludedOnProductPage();
             //
             if( !product_exclude && globalFields.isCustomer && globalFields.TradeMemberCustomer && customerMemberOrNot == 'Trade+'){
                jQuery('.row.product .flex_.wrap_.fl_between.al_center.price-review.rating_t4s_true').append(`<span class="ac-anncode-price">
                  ${ProductOriginalPrice}
                  <span > ${ProductUpdatedPrice} ${globalFields.VatPrice}</span> 
                  <span style="margin-left: 10px;font-size: initial;position: absolute;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 63 60">
                  <image width="63" height="60" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAA8CAYAAADRy2JxAAAEjElEQVRoQ+2bTUhVQRTHR1o8SJAMBCFFUQjKQvuAoE0gSO2EilpKgtuy3PvQvVltC8FlUUG7IBDdKAVBIX0QvFAyECTSFwRCUvf/ah73jTNzzv2ae+/LAcHHmztzfvd8zrn3Nfz2hvhPR8MefB1r/ufbd2J75UvlD6N58IIodLZX/jdqfmeznKlbsu9AUyB5yguLYvVmUQBejtYbI6Lj9kT1cw08gNcmp0R5frHmokC7JjQZ2uqamRZN585adwAsoAHvHyr4Ls1/ujgsvj97npD40ZeF9k9/+6hdSCpuY/ahUK0W4G3jY0K1nqrmcceWTw5ElzDBFUzwgC0Nj2oV1zJ0xTP1yV3gNZpfv3tfrN4qJih69KV18FAaLFYGNP8u+3t7xNG5J1rwGvi1iSnx1fP3LA/4fV/pZVVEuCg0rgvOFHju4A95fttWHKvAw1IRnHXgsJDjr19UU5pJoVWft2kei7VeHyEXS9JqGvt6BLTJAT/8dIbMCmzNH5l7zFosSXi5NhWbAI5ChjNIzdvSC2eDOOdszD7ygvK41tSxjy6X2/bPDTyi+vv+S7GBs8w+C5qnwDmRXWcBmdc8ovnyqQFtHgcQN7LnDt5WuUnw7pk7lQCHWr48vyR2tv4eyGANqO5y6/OoOBHdTUPmfVNpDvgu7+aEzvNp+TyV0vxgprmU7Jn0eSrAocxFBSdPaaYCLXfw8HOkNH8Twm+2AFIruLqB/+wdVFDMmAY6MShm/KMu4Ck/R1SH1tXhBF6mkx8LS+LX5lZFBvgf/poHz0eq/3EeRz439Q5h7idKr7RncyfwVOrBTUD6ofKrqjkAoyGh9t3882wHFifwEMbWOZHCosDomJ5gWwLVSKEOLM7gJSCn2UkJjbWgbaxlMnc1rekCoXN4CEFpTJaZpj4aldZwPed8ngq81NyH/svWGhpuAAj5pEROpm4ex3JsSnBS5MB0qRsAQWABshUVh7lTN9EJPNcC5A0odLRHiu6p5Hmrbf8LXhwLOOgVK7YqzlTMmPZPzedVgdBLR/QOO1T34KyTGXgISxVDNiB/b54DnnrA0wnJqQPU68L24jKleUBxcrgKH/b5QObgAYbDypvuMyzrDRrk/ItmEh4CUsdUzAkT5HIBDyHx3N/UmcH3YYJcbuBt5m87p7P8xZuUWbOXAKb0F1XrWB+Fla4X4Ky8pbSke/LCOa5S69piivoyg7qW09Y1Slo0KOXQNSMpWP/3VDDFm1tIn6bhFB5CIPUhBkTVOgWOvfC0xtZScw4vtR9F6xxwTi/AObxsVqK5EfStSm7dYHrvLlWfl5vjBqQNDlmcaz5IQAsS3DCXq3G5bi7guT6ue8XUdrNJeFyMF//U5mNYDQa9LilwltljEvIlHkKg9+Zq4HHY+r0H1pcTwpi6X36W5l0BB90nqI8HjvZBBXI1Pyo42+xdAXH3iQO8Bj5q15UreNR5cYHXwOODrLujCpjU9XGC74JHt6V0bTRzv69BNYgc3jJ0NVRlaFKG9tdVaAxsr6wlpcBA6xY620Rj77FYoaUAez8qDKSKOpr8B0bXpon91epwAAAAAElFTkSuQmCC"></image>
                  </svg>
                  <span style="display: inline-grid;line-height: 1;font-size: smaller;position: absolute;"> <b>Trade</b> <b> Member </b></span> </span></span>`);
             }
             else{
            
                jQuery('.row.product .flex_.wrap_.fl_between.al_center.price-review.rating_t4s_true').append(`<span class="ac-anncode-price">${ProductOriginalPrice}<span >${ProductUpdatedPrice} ${globalFields.VatPrice}</span></span>`);
             }
            const elements = document.querySelectorAll('.has_dpo_options #price_ppr ~ *');
          elements.forEach(element => {
              element.style.setProperty('display', 'block', 'important');
          });
  
}  //end WriteProductDiscountHtml function
 
  function isExcludedOnProductPage() {
     let product_Excluded = false;
     let product_id = globalFields.productId;
    let TradeDiscountTier = globalFields.AllProductsMetafield;
    product_Excluded = globalFields.AllProductsMetafield != '[]'  && globalFields.AllProductsMetafield.status? TradeDiscountTier?.excludeProducts.some(product => product.id == product_id) : product_Excluded;
    return product_Excluded
}
  
}

var globalFieldsProductPage_AC = new ACDiscountApp.PDPage.Global(), displayTiers = new ACDiscountApp.PDPage.DisplayTiers();
displayTiers.DisplayTiersFn(); 
      $(document).ready(function() {
        setTimeout(function() {
            displayTiers.DisplayTiersFn();//call this function for change the PDP price
        }, 4000);
      });